import PinIcon from "@medoma/components/icons/PinIcon";
import styles from "./Address.module.scss";
import type { IAddress } from "@medoma/models/addresses";
import {
  beautifyPostalCode,
  type InternalFormatPostalCode,
  type UnknownPostalCode,
} from "@medoma/models/postalCode";

const Address = ({
  icon = false,
  address,
  showPostalCode = false,
}: {
  icon?: boolean;
  address: IAddress<
    InternalFormatPostalCode[keyof InternalFormatPostalCode] | UnknownPostalCode
  > & {
    countryCode: "SE" | "CH" | "LV";
  };
  showPostalCode?: boolean;
}) => {
  const { addressLine1, city, postalCode, countryCode } = address;
  return (
    <div className={styles.address}>
      {icon ? <PinIcon /> : <></>}
      <address>{`${addressLine1}, ${
        showPostalCode ? `${beautifyPostalCode(postalCode, countryCode)} ` : ""
      } ${city}`}</address>
    </div>
  );
};

export default Address;
